import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';

import { media, breakpoints } from '../../styles/utils';
import { green, greenSecondary, cream, cream2 } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';

class Form extends Component {

    static defaultProps = {
        heading: 'Aesop',
        submitLabel: 'Log in',
        fields: [
            {
                type: 'text',
                name: 'username',
                placeholder: 'Username'
            }
        ]
    }

    state = {

    }

    onInputChange = (field, value) => {
        this.setState({
            [field]: value
        })
    }

    onInputKeyPress = () => {
        if (event.key === 'Enter') {
            this.props.callback({
                ...this.state
            })
        }
    }

    renderFields = () => {
        const { fields } = this.props;

        return fields.map((field, i) => {
            return (
                <Field
                    type={field.type || 'text'}
                    placeholder={field.placeholder || null}
                    onChange={(e) => this.onInputChange(field.name, e.target.value)}
                    onKeyPress={this.onInputKeyPress}
                    value={this.state[field.name] || null}
                />
            )
        })
    }
    
    render() {
        const { submitLabel, fields, callback, heading } = this.props;

        return (
            <Container>
                <Header>{heading}</Header>

                {this.renderFields()}

                <SubmitButton 
                    onClick={() => callback(this.state)}
                >
                    {submitLabel}
                </SubmitButton>
            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    border: 1px solid black;
`

const input = css`
    background: none;
    border: none;

    /* width: 100%; */
    display: flex;
    flex-direction: row
    align-items: center;
    height: 54px;
    border-bottom: 1px solid black;
    padding: 0 16px;
    font-size: 16px;
    border-radius: 0;
    margin: 0;
    
    & {
        color: black;
    }

    &::placeholder {
        opacity: 0.8;

    }

    &:focus { 
        outline: none;
    }
`

const Field = styled.input`
    ${input}
`

const Header = styled.div`
    height: 54px;
    background: black;
    display: flex;
    align-items: center;
    color: ${cream};
    padding: 0 16px;
    box-sizing: border-box;
`

const SubmitButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${hoverState}
    cursor: pointer;
    padding: 0 16px;
    text-align: center;
    height: 54px;
    background: ${cream2};
`

export default Form;


// WEBPACK FOOTER //
// ./client/components/Form/Form.js